import { render, staticRenderFns } from "./ChangeTwoFactorAuthentication.vue?vue&type=template&id=c3b354ca&"
import script from "./ChangeTwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./ChangeTwoFactorAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports